import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { NgxCaptchaModule } from 'ngx-captcha';


// Material Libs
import {MaterialModule} from './modules/material/material.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    MaterialModule
  ],
  exports: [
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    // RecaptchaModule,  // this is the recaptcha main module
    // RecaptchaFormsModule, // this is the module for form incase form validation
    NgxCaptchaModule,
    MaterialModule
  ]
})
export class SharedModule { }
